import React from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmButton } from '@common/components/confirm-button';
import Dropdown from '../../../../common/components/dropdown';
import Icon from '../../../../common/components/icon';
import { FullConversation } from '@modules/chat/types/objects';

interface ConversationArchivedActionsProps {
  conversation: FullConversation;
  onUnarchive: (conversationId: string) => void;
  onRemoveConversation: (conversationId: string) => void;
}

const ConversationArchivedActions = ({
  conversation, onUnarchive, onRemoveConversation,
}: ConversationArchivedActionsProps) => {
  const { t } = useTranslation();
  const actionsLabel = t('chat:conversation_actions_button', { defaultValue: 'Conversation actions' });

  return (
    <Dropdown
      alignRight
      toggle={(
        <button
          type="button"
          aria-label={actionsLabel}
          className={`ConversationActions__Trigger tw-inline-flex tw-items-center tw-border-0 tw-bg-transparent tw-justify-center
            tw-rounded-full tw-p-1`}
        >
          <Icon
            className="ConversationActions"
            type="more_vert"
          />
        </button>
      )}
    >
      <Dropdown.Item onClick={() => onUnarchive(conversation.id)}>
        {t('chat:conversation_unarchive')}
      </Dropdown.Item>

      <ConfirmButton
        title={t('chat:conversation_remove_confirm_title')}
        onConfirm={() => onRemoveConversation(conversation.id)}
      >
        <Dropdown.Item danger>
          {t('chat:remove_conversation')}
        </Dropdown.Item>
      </ConfirmButton>
    </Dropdown>
  );
};

export default ConversationArchivedActions;
